import { Form as Formio } from "react-formio";
import "./LeadDetailNew.scss";
import {ReactComponent as IconEdit} from "../../../../assets/images/edit_border.svg";
import { useState } from "react";
import { Button, Modal } from "antd";
import API_SERVICE from "shared/services/api-service";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import { getMaskedMobile, hasUserRole } from "shared/services/Utility";

interface IProductSteps {
  getTaskData: any;
  submitTask: any;
  leadData: any;
  getJSONSchema: any;
  formJsonSchema: any;
  isStepReadOnly: any;
  currentSteps: any;
  getNextTask: any;
  setGetTaskData: any;
  isDecisioningTabAvailable: boolean;
  isMaskMobileNumber?: string | null;
}

const ProductSteps: React.FC<IProductSteps> = (props: IProductSteps) => {
  const {
    getTaskData,
    submitTask,
    leadData,
    getJSONSchema,
    formJsonSchema,
    isStepReadOnly,
    currentSteps,
    getNextTask,
    setGetTaskData,
    isDecisioningTabAvailable,
    isMaskMobileNumber,
  } = props;
  
  const jsonSchema = getJSONSchema(formJsonSchema ?? "{}");
  const [isEditDetils, setIsEditDetails] = useState(false);
  const {appColors}: any = useSelector((state: RootState) => state.common);
  let tmpFormData = JSON?.parse(getTaskData?.formData ?? "{}") as any;

  const handleEditClick = () => {
    API_SERVICE.checkEditProspect({caseId: leadData?.caseDetails?.caseId})
        .then(({data}:any) => {
          if(data?.payload?.showWarningPopup){
            setIsEditDetails(true)
          } else {
            actionEditOk()
          }
        })
        .catch((error) => {
            setIsEditDetails(true);
            API_SERVICE.handleErrors(error);
        });
  };

  const onSubmit = (value) => {
    let data = value?.data
    if(data?.mobileNumber.includes("X")) {
      data = {...data, mobileNumber : data.mobileNumberORG}
    }
    if(data?.coapplicantMobileNumber.includes("X")) {
      data = {...data, coapplicantMobileNumber : data.coapplicantMobileNumberORG}
    }
    if(data?.coapplicant2MobileNumber.includes("X")) {
      data = {...data, coapplicant2MobileNumber : data.coapplicant2MobileNumberORG}
    }
    if(data?.officePhoneNumber.includes("X")) {
      data = {...data, officePhoneNumber : data.officePhoneNumberORG}
    }
    if(data?.coapplicant1Details?.mobileNumber.includes("X")) {
      data = {
        ...data, 
        coapplicant1Details: {
          ...data?.coapplicant1Details,
          mobileNumber : data?.coapplicant1Details?.mobileNumberORG
        }
      }
    }
    if(data?.coapplicant2Details?.mobileNumber.includes("X")) {
      data = {
        ...data, 
        coapplicant2Details: {
          ...data?.coapplicant1Details,
          mobileNumber : data?.coapplicant2Details?.mobileNumberORG
        }
      }
    }

    let tmpObj = Object.assign(tmpFormData, { ...data })
    setGetTaskData({...getTaskData, formData: JSON?.stringify(tmpObj)})
    const payload = {
      formData: JSON?.stringify(data),
      taskDefinitionKey: getTaskData?.taskDefinitionKey,
      taskId: getTaskData?.taskId,
    };
    submitTask(payload);
  };
  const callbackForMobile = (actionType: string) => {
    window["ReactNativeWebView"] &&
      window["ReactNativeWebView"].postMessage(
        JSON.stringify({ actionType: actionType })
      );
  };

  const btnDefaultBorderStyle: any = {'--borderColor': appColors?.appSecondaryColor ?? "",width: "100px" };
  const btnPrimaryStyles : any = {'--btnColor' :appColors?.appPrimaryColor ?? "",width: "100px" };

  const actionEditOk = () => {
    setIsEditDetails(false);
    callbackForMobile('EDIT_BUTTON_CLICK');
    getNextTask({
      processInstanceId: leadData?.processInstanceId,
      gotoStep: currentSteps,
      // clientType: "WEB",
    });
    API_SERVICE.purgeAllCaseDecisioningData(
      leadData?.caseDetails?.caseId
    )
      .then((data) => { })
      .catch((e: any) => API_SERVICE.handleErrors(e));   
  }

  function removeNullUndefinedWithReduce(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
            acc[key] = (typeof value === 'object' && !Array.isArray(value)) ? removeNullUndefinedWithReduce(value) : value;
        }
        return acc;
    }, {});
  }

  const createData = () => {
    const userRolePermission = hasUserRole();
    const isMasked = userRolePermission["MaskMobileNumber"] ?? isMaskMobileNumber == "true";

    const data = removeNullUndefinedWithReduce(tmpFormData) as any;

    data.mobileNumberORG = data?.mobileNumber;
    data.mobileNumber = getMaskedMobile(isMasked, data?.mobileNumber);

    data.coapplicantMobileNumberORG = data?.coapplicantMobileNumber
    data.coapplicantMobileNumber = getMaskedMobile(isMasked, data?.coapplicantMobileNumber);

    data.coapplicant2MobileNumberORG = data?.coapplicant2MobileNumber
    data.coapplicant2MobileNumber = getMaskedMobile(isMasked, data?.coapplicant2MobileNumber);

    data.officePhoneNumberORG = data?.officePhoneNumber
    data.officePhoneNumber = getMaskedMobile(isMasked, data?.officePhoneNumber);

    if(Object.keys(data?.coapplicant1Details ?? {}).length > 0) {
      data.coapplicant1Details.mobileNumberORG = data?.coapplicant1Details?.mobileNumber;
      data.coapplicant1Details.mobileNumber = getMaskedMobile(isMasked, data?.coapplicant1Details?.mobileNumber);
    }

    if(Object.keys(data?.coapplicant2Details ?? {}).length > 0) {
      data.coapplicant2Details.mobileNumberORG = data?.coapplicant2Details?.mobileNumber;
      data.coapplicant2Details.mobileNumber = getMaskedMobile(isMasked, data?.coapplicant2Details?.mobileNumber);
    }

    return data
  }

  const renderEditModal = () => (
    <Modal
      width={450}
      visible={isEditDetils}
      closable={false}
      maskClosable={false}
      footer={false}
      centered
    >
      <div style={{ padding: "30px" }}>
        <p
          style={{
            textAlign: "center",
            fontSize: "18px",
            marginBottom: "30px",
          }}
        >
           Editing will clear and reset your decisioning output. You will need to rerun decisioning. Do you wish to continue?
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <Button
            className="dynamic-btn-default"
            style={btnDefaultBorderStyle}
            size="middle"
            onClick={() => setIsEditDetails(false)}
          >
            Cancel
          </Button>
          <Button
            size="middle"
            type="primary"
            className="dynamic-btn-primary"
            style={btnPrimaryStyles}
            onClick={() => actionEditOk()}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
  
  return (
    <>
      {isStepReadOnly && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
              className="custome-btn-icon"
              style={{'--bgColor': appColors?.appPrimaryColor ?? ""} as any}
              size="small"
              type="text"
              onClick={() => {
                if(isDecisioningTabAvailable) {
                  // setIsEditDetails(true);
                  handleEditClick();
                } else {
                  actionEditOk();
                }
              }}
              icon={<IconEdit />}
            />
        </div>
      )}
      <div className="dynamic-formio"
        style={{ '--btnColor': appColors?.appPrimaryColor ?? "" } as any}>
        <Formio
          options={{
            readOnly: isStepReadOnly,
            renderMode: isStepReadOnly ? "html" : "",
          }}
          key={isStepReadOnly ? currentSteps : getTaskData?.taskDefinitionKey}
          submission={{ data: createData() }}
          form={jsonSchema}
          jsonSchema={jsonSchema}
          onSubmit={onSubmit}
        // onCustomEvent={() => setTestDecision(false)}
        />
      </div>
      {isEditDetils && renderEditModal()}
    </>
  );
};

export default ProductSteps;
